export const languageElements = {
    items: {
      "form-title": {
        hu: "CUSTOMER PORTAL LEIRATKOZÁS",
        de: "CUSTOMER PORTAL ABMELDUNG",
        en: "CUSTOMER PORTAL UNSUBSCRIBE",
      },
  
      "form-text": {
        hu: "A „Leiratkozás“ gombra kattintva törlődnek adatai a rendszerből.",
        de: "Durch Klicken auf Button „Abmelden“ werden Ihre Daten aus dem System gelöscht.",
        en: "By clicking the 'Unsubscribe' button, your data will be deleted from the system.",
      },
  
      "btn-submit": {
        hu: "Leiratkozás",
        de: "Abmeldung",
        en: "Unsubscribe",
      },

      "MESSAGE_DATA_SUCCESSFULLY_UNSUBSCRIBED-title": {
        hu: "Sikeres leiratkozás",
        de: "Erfolgreiche Abmeldung",
        en: "Successful unsubscribe",
      },
    },
  };
  